import React from "react";
import { NavLink, Link } from "react-router-dom";
import "../SideBar/SideBar.css";
import logo from "../../assets/images/TR-logo.png";
import logoMini from "../../assets/images/logo-mini.png";
import { AUTH_CODE } from "../security/authCodes.js";
import { useAuth } from "../security/authContext.js";

const HIDDEN_MENU_PERMISSIONS = new Set([
  AUTH_CODE.instreamAdSetup.instreamListing,
  AUTH_CODE.instreamTagSetting.manageInstreamSetting,
  AUTH_CODE.invoiceSetting.createUpdateInvoiceSetting,
  AUTH_CODE.financeInvoice.invoiceListing,
  AUTH_CODE.gamSetting.createUpdateGamSetting,
]);

const SideBarPub = ({ collapsed, menuItems, isMobile, onToggleSidebar }) => {
 const { hasPermission } = useAuth();
  const handleMenuClick = () => {
    if (isMobile) {
      onToggleSidebar();
    }
  };
  return (
    <div className="sideBar">
      <div className='logo' style={{ display: isMobile ? 'none' : 'block' }}> <Link to="/dashboard">{collapsed ? <img src={logoMini} /> : <img src={logo} />} </Link></div>
      <ul className="list-unstyled parentList">
        {menuItems
          .filter(({ permission, children }) => !HIDDEN_MENU_PERMISSIONS.has(permission) && !children)
          .map(({ path, icon, name, permission }, index) => {
            if (name !== "Dashboard") {
              if (!hasPermission(permission)) {
                return false;
              }
            }
            return (
              <li key={path || index}>
                <NavLink to={path} end className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} onClick={handleMenuClick}>
                  {icon && <span className="icon">{icon}</span>}
                  {!collapsed && (
                    <span className="name">
                      {name}
                    </span>
                  )}
                </NavLink>
              </li>
            )

          })}
      </ul>
    </div>
  );
};

export default SideBarPub;